export enum MandatoryActionTypes {
    Raise = 1, 
    Alert = 2, 
}